export default "__VITE_ASSET__PYeg7iEn__"